export default __webpack_public_path__ + "static/media/Baby30.b8ca1d2e.gif";